const AppraisalSteps = {
  0: 'entry',
  1: 'vehicle',
  2: 'basics',
  3: 'features',
  4: 'condition',
  5: 'viewoffer',
  Entry: 0,
  Vehicle: 1,
  Basics: 2,
  Features: 3,
  Condition: 4,
  ViewOffer: 5
};

export default AppraisalSteps;
